import React, {Component} from 'react';
import {Popup, Image} from 'semantic-ui-react';

class HomePage extends Component {

  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {

  }

  render() {

    return (
      <div>
        <Popup
          hoverable
          header="Welcome to New York City Landmarks and Preservation Commission (LPC)"
          content="
          LPC records the designations into New York City's Automated City Register
          Information System (ACRIS) via this system electronically.
          The steps involved are as follows:
            1. Select the designated Landmark
            2. Review the properties on the designation
            3. Review the designation notice
            4. Get the designation notice notarized
            5. Upload the notarized document
            6. The system now validates the properties and reports any errors
            7. Once all the errors are resolved, proceed to the next step where the system will make the submission and return a preview of the coverpage
            8. If all looks good, proceed to Submit to DOF
            9. This will trigger the review process at DOF and you will be informed when the submission is accepted/rejected
            10. You can review your submissions via the Review Submissions link
          "
          trigger={<Image src="./images/home.png" alt="NYCLPC" /> }
            />
            </div>
    )
  }
}

export default HomePage




// WEBPACK FOOTER //
// ./src/components/HomePage.js